import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class MissingExchangeRateCombinationsReportCriteria extends ValueObject  
{
    public staticServiceProviderId: number = 0;

    public serviceProviderName: string = "";
}